'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var classnames = _interopDefault(require('classnames'));
var icon_treat = require('../components/Icons/icon.treat.js');
var Button_treat = require('../components/Button/Button.treat.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getButtonStyle = function getButtonStyle(type, size, disabled) {
  var _classnames2;

  var bsStyle = {
    primary: 'primary',
    secondary: 'default',
    link: 'link',
    delete: 'confirm-delete',
    clear: 'clear'
  }[type];
  var isSizeXs = size === 'xs';
  var isTypeLink = type === 'link';
  var verticalPadding = !isSizeXs && {
    paddingTop: 'xTiny',
    paddingBottom: 'xTiny'
  };
  return {
    buttonClasses: classnames(Button_treat.button.base, _defineProperty({}, Button_treat.button.minWidth, !isSizeXs && !isTypeLink), Button_treat.type[type], [icon_treat.overrides.button], (_classnames2 = {}, _defineProperty(_classnames2, icon_treat.overrides.buttonSecondary, type === 'secondary'), _defineProperty(_classnames2, icon_treat.overrides.buttonSecondaryHover, type === 'secondary' && !disabled), _defineProperty(_classnames2, "disabled", disabled), _defineProperty(_classnames2, Button_treat.disabled, disabled), _classnames2), Button_treat.size[size], 'btn', "btn-".concat(bsStyle), _defineProperty({}, "btn-".concat(size), size)),
    boxProps: _objectSpread(_objectSpread({
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, verticalPadding), {}, {
      paddingLeft: !isSizeXs && !isTypeLink ? 'xs' : undefined,
      paddingRight: !isSizeXs && !isTypeLink ? 'xs' : undefined,
      marginBottom: 'clear',
      textAlign: 'center',
      verticalAlign: 'middle',
      borderRadius: 'sm'
    })
  };
};

exports.default = getButtonStyle;
